<template>
  <div class="user-manage">
    <head-panel title="账号管理" subtitle="ACCOUNT MANAGEMENT" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit">
        <!--{{currentTitle}}-->
      </h3>
      <el-tabs v-model="mediaTab" @tab-click="handleClick" class="is-simple" v-if="isAdver">
        <el-tab-pane label="多牛账户信息" name="1"></el-tab-pane>
        <el-tab-pane label="小米账户信息" name="2" :disabled="donewsStatus !== '1'"></el-tab-pane>
        <el-tab-pane label="掌阅账户信息" name="3" :disabled="donewsStatus !== '1'"></el-tab-pane>
      </el-tabs>
      <el-form
        :model="commonForm"
        ref="commonForm"
        class="ruleForm"
        label-width="12%;"
        v-if="mediaTab !== '1' && !isAgency"
      >
        <h4 class="form-title">账户信息</h4>
        <el-form-item
          label="行业类型"
          prop="industrySecondType"
          v-if="!isAgency"
          :rules="[{ required: true, message: '请选择行业类型', trigger: 'blur' }]"
        >
          <ny-select
            :data="accountinfo.commonForm.industryMenu"
            v-model="commonForm.industryType"
            :keyValue="['id', 'name']"
            @change="({ value }) => changeIndustry({value: value, form:'commonForm', isEdit: commonForm.isEdit })"
            type="industryType"
            placeholder="请选择"
            class="advertiseSelect input_sm mr20"
            :disabled="commonForm.isEdit"
          ></ny-select>
          <ny-select
            :data="accountinfo.commonForm.industrySecondMenu"
            v-model="commonForm.industrySecondType"
            @change="({ value }) => changeIndustrySecondType({value: value, form:'commonForm', isEdit: commonForm.isEdit })"
            :keyValue="['id', 'name']"
            type="industryType"
            placeholder="请选择"
            :disabled="commonForm.isEdit"
            class="advertiseSelect input_sm"
          ></ny-select>
        </el-form-item>
        <Industry
          :industryData.sync="industryData"
          :post="post"
          ref="industry"
          :loading="commonForm.loading"
          :deleteArray="deleteArray"
          :disabled="industryDisabled"
        ></Industry>
        <el-form-item class="btnGroups">
          <el-button
            v-if="!isShow"
            class="commit"
            type="primary"
            @click="submitMediaForm('commonForm')"
            :disabled="commonForm.committing"
          >{{commonForm.committing ? '提交中···' : '提交'}}</el-button>
          <el-button
            class="is-cancel"
            type="primary"
            size="large"
            @click="cancel"
          >{{isShow ? '返回': '取消'}}</el-button>
        </el-form-item>
      </el-form>
      <el-form
        :model="form"
        ref="form"
        class="ruleForm"
        :rules="rules"
        label-width="12%"
        v-if="mediaTab === '1'"
      >
        <h4 class="form-title">账户信息</h4>
        <el-form-item label="账户名称" prop="name">
          <el-input class="input_lg" placeholder="请输入账户名称" v-model="form.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="公司名称(广告主名称)" prop="company" disabled>
          <el-input class="input_lg" placeholder="请输入公司名称(广告主名称)" v-model="form.company" disabled></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input class="input_sm" placeholder="请输入邮箱" v-model="form.email" :disabled="isShow"></el-input>
        </el-form-item>
        <el-form-item label="网站URL" prop="url">
          <el-tooltip effect="dark" :content="form.url" placement="bottom-start">
            <el-input v-model="form.url" class="input_lg" placeholder="请输入网站URL" disabled></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item
          label="密码管理"
          class="labelOK"
          v-if="type==='edit'"
          :rules="[{ required: true, message: '请输入登录密码', trigger: 'blur' }]"
        >
          <el-button @click="dialogFormVisible=true" :disabled="isShow">修改密码</el-button>
        </el-form-item>
        <el-form-item label="行业类型" prop="industryType" v-if="!isAgency">
          <ny-select
            :data="accountinfo.form.industryMenu"
            v-model="form.industryType"
            :keyValue="['id', 'name']"
            @change="({ value }) => changeIndustry({value: value, form:'form', isEdit: true })"
            type="industryType"
            placeholder="请选择"
            class="advertiseSelect input_sm mr20"
            disabled
          ></ny-select>
          <ny-select
            :data="accountinfo.form.industrySecondMenu"
            v-model="form.industrySecondType"
            :keyValue="['id', 'name']"
            type="industryType"
            placeholder="请选择"
            disabled
            class="advertiseSelect input_sm"
          ></ny-select>
        </el-form-item>
        <Industry
          :industryData.sync="industryData"
          :post="post"
          ref="industry"
          :deleteArray="deleteArray"
          :disabled="industryDisabled"
        ></Industry>
        <el-form-item label="注册地址">
          <city-select
            class="address-select"
            :arrCity="accountinfo.cityArr"
            @changeSelect="changeSelectCity"
            part="registerCity"
            :disabled="isShow"
            :defaultCity="form.registerCity"
          ></city-select>
          <el-input
            class="input_lg ml16"
            placeholder="请输入地址"
            v-model="form.address"
            :disabled="isShow"
          ></el-input>
        </el-form-item>
        <h4 class="form-title">财务信息</h4>
        <el-form-item label="对公银行名称" prop="publicBank">
          <ny-select
            :data="menuList"
            v-model="form.publicBank"
            :keyValue="['value', 'name']"
            @change="changeSelect"
            part="publicBank"
            :disabled="isShow"
            placeholder="请选择"
            class="advertiseSelect input_sm"
          ></ny-select>
        </el-form-item>
        <el-form-item label="对公开户支行" prop="bankAddress">
          <city-select
            class="address-select"
            part="bankCity"
            :arrCity="accountinfo.cityArr"
            @changeSelect="changeSelectCity"
            :defaultCity="form.bankCity"
            :disabled="isShow"
          ></city-select>
          <el-input
            class="input_lg ml16"
            placeholder="请输入对公开户支行"
            v-model="form.bankAddress"
            :disabled="isShow"
          ></el-input>
        </el-form-item>
        <el-form-item label="对公银行账号" prop="bankNum">
          <el-input
            class="input_lg"
            placeholder="请输入对公银行账号"
            v-model="form.bankNum"
            :disabled="isShow"
            type="age"
          ></el-input>
        </el-form-item>
        <h4 class="form-title">联系人信息</h4>
        <el-form-item label="联系人姓名" prop="contacter">
          <el-input
            class="input_sm"
            placeholder="请输入联系人姓名"
            v-model="form.contacter"
            :disabled="isShow"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="phone">
          <el-input class="input_sm" placeholder="请输入手机号" v-model="form.phone" :disabled="isShow"></el-input>
        </el-form-item>
        <el-form-item label="联系人地址" prop="linkAddress">
          <city-select
            class="address-select"
            part="linkCity"
            :arrCity="accountinfo.cityArr"
            @changeSelect="changeSelectCity"
            :defaultCity="form.linkCity"
            :disabled="isShow"
          ></city-select>
          <el-input
            class="input_lg ml16"
            placeholder="请输入地址"
            v-model="form.linkAddress"
            :disabled="isShow"
          ></el-input>
        </el-form-item>
        <h4 class="form-title" v-if="type==='review'">审核状态</h4>
        <el-form-item label="审核" class="labelOK" v-if="type==='review'">
          <el-radio-group v-model="reviewValue" class="radioW183">
            <el-radio
              :label="item.value"
              v-for="(item) in reviewList"
              :key="item.value"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label class="labelOK" v-show="reviewValue === '2'" v-if="type==='review'">
          <el-input type="textarea" v-model="reviewReason" placeholder="请输入拒绝原因"></el-input>
        </el-form-item>
        <el-form-item class="btnGroups">
          <el-button
            v-if="!isShow"
            class="commit"
            type="primary"
            @click="submitForm('form')"
            :disabled="committing"
          >{{committing ? '提交中···' : '提交'}}</el-button>
          <el-button
            class="is-cancel"
            type="primary"
            size="large"
            @click="cancel"
          >{{isShow ? '返回': '取消'}}</el-button>
        </el-form-item>
      </el-form>
      <el-dialog title="密码管理" :visible.sync="dialogFormVisible">
        <el-form
          :model="passwordList"
          ref="passwordList"
          label-width="22%"
          :rules="rulePasswordList"
        >
          <el-form-item label="登录密码" class="labelOK" prop="password">
            <el-input
              v-model="passwordList.password"
              class="taskInput"
              type="password"
              placeholder="请输入登录密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" class="labelOK" prop="confirmPassword">
            <el-input
              v-model="passwordList.confirmPassword"
              class="taskInput"
              type="password"
              placeholder="请再次输入登录密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" class="is-cancel" size="large">取 消</el-button>
          <el-button type="primary" @click="confirmUpdatePassword('passwordList')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { headPanel, NySelect, citySelect } from '@/global/components';
import Industry from '@/global/views/subAccount/industry.vue'
import IndustryMixns from '@/global/views/subAccount/industry.js'
import { post, get, patch, remove } from '@/manager/http';
import { CityAll } from '@/global/util/City';
export default {
  mixins: [IndustryMixns],
  data () {
    var validatePass = (rule, value, callback) => {
      let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,20}$/
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length > 20 || value.length < 6) {
        callback(new Error('密码长度不少于6个字符,不超过20个字符'));
      } else if (!re.test(value)) {
        callback(new Error('密码至少包含大写字母，小写字母，数字'));
      } else {
        if (this.passwordList.confirmPassword !== '') {
          this.$refs.passwordList.validateField('confirmPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passwordList.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var industryType = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择行业类型'));
      } else {
        callback();
      }
    };
    var publicBank = (rule, value, callback) => {
      if (value === '') {
        callback();
      } else {
        callback();
      }
    };
    var subBranch = (rule, value, callback) => {
      if (value === '') {
        // callback(new Error('请输入对公开户支行'));
        callback()
      } else if (value && value.toString().length > 50) {
        callback(new Error('输入内容不得超过50个字符'))
      } else {
        callback();
      }
    };
    var bankNum = (rule, value, callback) => {
      let reg = /^[0-9\s]*$/
      if (!value) {
        // callback(new Error('请输入银行账号'));
        callback()
      } else if (!reg.test(value)) {
        callback(new Error('请输入数字'))
      } else if (value && value.toString().length > 50) {
        callback(new Error('输入内容不得超过50个字符'))
      } else {
        callback()
      }
    };
    return {
      post: post,
      get: get,
      patch: patch,
      remove: remove,
      userid: '',
      qua_id: '',
      isShow: false,
      type: '', // 标识当前页面是编辑还是审核
      dialogFormVisible: false, // 修改密码弹窗是否弹出标识
      isAgency: false,
      isAdver: false,
      passwordList: {
        password: '', // 登录密码
        confirmPassword: '' // 确认密码
      },
      rulePasswordList: {
        password: [{ required: true, validator: validatePass, trigger: 'blur' }],
        confirmPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }]
      },
      update: false, // 是否修改密码
      committing: false, // 提交按钮的提交状态
      currentTitle: '账户信息',
      uploadPost: 'test',
      isNew: false,
      menuList: [],
      form: {
        name: '',
        pass: '',
        checkPass: '',
        email: '',
        company: '',
        industryType: '',
        url: '',
        address: '',
        registerCity: {},
        contacter: '',
        phone: '',
        linkAddress: '',
        linkCity: {},
        publicBank: '',
        bankCity: {},
        subBranch: '',
        bankAddress: '',
        bankNum: '',
        loading: false
      },
      rules: {
        name: [{ required: true, message: '请输入账户名称', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }
        ],
        company: [{ required: true, message: '请输入公司名称(广告主名称)', trigger: 'blur' }],
        industryType: [{ required: true, validator: industryType, trigger: 'change' }],
        url: [{ required: false, message: '请输入网站url', trigger: 'blur' },
          { required: false, type: 'url', message: '请输入正确网站url', trigger: 'blur,change' }],
        publicBank: [{ validator: publicBank, trigger: 'change' }],
        bankAddress: [{ validator: subBranch, trigger: 'change' }],
        bankNum: [{ validator: bankNum, trigger: 'blur' }],
        contacter: [{ required: false, max: 50, message: '输入内容不得超过50个字符', trigger: 'blur' }],
        phone: [{ required: false, pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }],
        linkAddress: [{ required: false, max: 50, message: '输入内容不得超过50个字符', trigger: 'blur' }]
      },
      accountinfo: {
        quaTypeMenu: [], // 资质类型列表
        industryMenu: [], // 行业类型
        cityArr: [{ name: {} }] // 省市区
      },
      reviewList: [ // 审核
        { value: '1', name: '通过' },
        { value: '2', name: '拒绝' }
      ],
      reviewValue: '', // 审核的值
      reviewReason: '' // 审核原因
    };
  },
  computed: {
    CityAll () {
      return CityAll;
    }
  },
  created () {
    this.userid = this.$route.params.id
    this.type = this.$route.params.type
    this.industryDisabled = this.isShow = this.$route.params.type === 'show'
    this.donewsStatus = this.$route.params.donewsStatus
    let userType = [2, 3]
    this.isAdver = userType.indexOf(parseInt(this.$route.params.userType)) > -1
    this.setSomeItem()
  },
  methods: {
    ...mapActions(['subAccount/userItem', 'subAccount/userList', 'subAccount/updateUser', 'subAccount/reviewUser']),
    getItem (params, cb) {
      this['subAccount/userItem']({ data: params }).then(data => {
        if (data && data.code === 1) {
          cb(data.data)
        }
      })
    },
    async setSomeItem () {
      this.getItem('qua_type', data => { // 获取资质列表数据
        this.accountinfo.quaTypeMenu = data
      })
      this.getItem('industry', data => { // 获取行业列表数据
        this.accountinfo.industryMenu = data
      })
      await this.getItem('china-area', data => { // 获取开户支行
        this.accountinfo.cityArr = data
        this.getAccountInfo()
      })
      this.getItem('bank_name', data => { // 获取对公银行名称
        this.menuList = data
      })
    },
    getAccountInfo () {
      this['subAccount/userList']({ data: { id: this.userid } }).then(async data => {
        if (data && data.code === 1) {
          // 账号信息
          let AgencyIdTag = ['4', '11', '12', '13']
          this.isAgency = AgencyIdTag.indexOf(data.data.id_tag) > -1
          this.getIndustryDetails(this.isAgency)
          this.role_id = data.data.id
          this.form.name = data.data.username
          this.form.company = data.data.corporate_name
          this.form.industryType = data.data.parent_industry + ''
          await this.getIndustryMenu({ type: this.form.industryType })
          this.form.industrySecondType = data.data.industry + ''
          this.commonForm.xiaomi.industryType = data.data.mi_parent_industry !== '0' ? data.data.mi_parent_industry + '' : ''
          this.commonForm.xiaomi.industrySecondType = data.data.mi_industry !== '0' ? data.data.mi_industry + '' : ''
          this.commonForm.zhangyue.industryType = data.data.ireader_parent_industry !== '0' ? data.data.ireader_parent_industry + '' : ''
          this.commonForm.zhangyue.industrySecondType = data.data.ireader_industry !== '0' ? data.data.ireader_industry + '' : ''
          // this.commonForm.isEdit = data.data.mi_industry !== '0'
          this.donewsStatus = data.data.audit_status + ''
          this.form.url = data.data.web_url
          this.form.email = data.data.email
          if (data.data.qualification) {
            let params = data.data.qualification
            // 资质
            this.qua_id = params.id
            this.form.registerCity = {
              prov: params.reg_pro ? params.reg_pro + '' : '',
              city: params.reg_city ? params.reg_city + '' : '',
              district: params.reg_area ? params.reg_area + '' : ''
            }
            this.form.address = params.reg_address
            // 财务信息
            this.form.publicBank = params.bank
            this.form.bankCity = {
              prov: params.bank_pro ? params.bank_pro + '' : '',
              city: params.bank_city ? params.bank_city + '' : '',
              district: params.bank_area ? params.bank_area + '' : ''
            }
            this.form.bankAddress = params.bank_addr
            this.form.bankNum = params.account
            // 联系人信息
            this.form.contacter = params.username
            this.form.phone = params.tel
            this.form.linkCity = {
              prov: params.pro ? params.pro + '' : '',
              city: params.city ? params.city + '' : '',
              district: params.area ? params.area + '' : ''
            }
            this.form.linkAddress = params.address
            // 审核状态
            if (this.type === 'review') {
              this.reviewValue = params.audit.status + ''
              this.reviewReason = params.audit.reason
            }
          }
        }
      })
    },
    changeSelect (value) {

    },
    changeSelectCity ({ prov, city, district, part }) {
      this.form[part] = { prov, city, district, part }
    },
    confirmUpdatePassword (passwordList) {
      let flag = false
      this.$refs[passwordList].validate((valid) => {
        if (!valid) {
          flag = true
        }
      })
      if (!flag) {
        this.update = true
        this.dialogFormVisible = false
      }
    },
    // 修改密码 上传参数
    getPasswordParams () {
      let params = this.getParams()
      params.password = this.passwordList.password
      params.password_confirmation = this.passwordList.confirmPassword
      return params
    },
    getParams () {
      let params = {}
      // 账号信息
      params.id = this.role_id
      params.user_name = this.form.name
      params.email = this.form.email
      params.corporate_name = this.form.company
      params.industry = this.isAgency ? '' : this.form.industrySecondType
      params.web_url = this.form.url
      params.reg_pro = this.form.registerCity.prov
      params.reg_city = this.form.registerCity.city
      params.reg_area = this.form.registerCity.district
      params.reg_address = this.form.address
      // 联系人信息
      params.username = this.form.contacter
      params.tel = this.form.phone
      params.pro = this.form.linkCity.prov
      params.city = this.form.linkCity.city
      params.area = this.form.linkCity.district
      params.address = this.form.linkAddress
      // 财务信息
      params.bank = this.form.publicBank
      params.bank_pro = this.form.bankCity.prov
      params.bank_city = this.form.bankCity.city
      params.bank_area = this.form.bankCity.district
      params.bank_addr = this.form.bankAddress
      params.account = this.form.bankNum
      return params
    },
    submitForm (numberValidateForm) {
      if (this.type === 'review') {
        if (this.reviewValue === '' || this.reviewValue === '0') {
          this.$message({
            showClose: true,
            message: '请审核',
            type: 'warning'
          });
        } else {
          this.committing = true;
          this['subAccount/reviewUser']({ id: this.qua_id,
            data: {
              audit_status: this.reviewValue,
              reason: this.reviewReason
            } }).then(data => {
            if (data && data.code === 1) {
              this.$confirm('审核成功！', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'success'
              }).then(() => {
                this.$router.push('/userList');
              })
            } else {
              this.committing = false;
              this.$message.error(data.msg)
            }
          }).catch(() => {
            this.committing = false
          })
        }
      } else {
        this.$refs[numberValidateForm].validate((valid) => {
          this.$refs.industry.$refs.industryForm.validate((validIn) => {
            if (valid && validIn) {
              this.committing = true;
              let promiseArr = [
                this['subAccount/updateUser']({
                  id: this.userid,
                  data: this.update ? this.getPasswordParams() : this.getParams()
                }),
                this.submitIndustry({ form: numberValidateForm })
              ]
              if (this.deleteArray.length > 0) {
                promiseArr.push(this.submitDelete())
              }
              Promise.all(promiseArr).then(data => {
                let suc = data.every(res => {
                  if (res.code !== 1) {
                    this.committing = false;
                    this.$message.error(res.msg)
                  }
                  return res.code === 1
                })
                if (suc) {
                  this.$confirm('编辑成功！', '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    callback: () => {
                      this.$router.push('/userList');
                    },
                    type: 'success'
                  });
                }
              }).catch(() => {
                this.committing = false
              })/*
              this['subAccount/updateUser']({
                id: this.userid,
                data: this.update ? this.getPasswordParams() : this.getParams()
              }).then(data => {
                if (data && data.code === 1) {
                  this.submitIndustry().then(res => {
                    console.log(res)
                    if (res && res.code === 1) {
                      this.$confirm('编辑成功！', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        callback: () => {
                          this.$router.push('/userList');
                        },
                        type: 'success'
                      });
                    } else {
                      this.committing = false;
                      this.$message.error(data.msg)
                    }
                  }).catch(() => {
                    this.committing = false
                  })
                } else {
                  this.committing = false;
                  this.$message.error(data.msg)
                }
              }).catch(() => {
                this.committing = false
              }) */
            }
          })
        });
      }
    },
    cancel () {
      this.form.pass = '';
      this.form.checkPass = '';
      this.$router.push('/userList')
    }
  },
  components: {
    headPanel,
    NySelect,
    citySelect,
    Industry
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.user-manage {
  .el-tabs.is-simple {
    .el-tabs__active-bar {
      width: 129px !important;
    }
    .el-tabs__item {
      text-align: center;
      width: 140px;
    }
    .el-tabs__header {
      margin-bottom: 0px;
    }
  }
  .ruleForm {
    padding: 0;
    margin: 30px auto;
    .input_sm {
      width: 210px;
    }
    .input_lg {
      width: 350px;
    }
    .ml16 {
      margin-left: 16px;
    }
    .mr20 {
      margin-right: 20px;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .upload_select {
      position: absolute;
      left: 16px;
    }
    .ml136 {
      margin-left: 136px;
    }
    .upload-demo {
      width: 310px;
      .el-upload__tip {
        position: absolute;
        top: -7px;
        left: 90px;
      }
    }
    .col-upload {
      margin-left: 16px;
      .el-upload__tip {
        position: absolute;
        top: 23px;
        left: 90px;
      }
      .el-upload-list {
        margin-left: 0;
      }
    }
    .form-title {
      font-size: 16px;
      margin: 30px 50px;
      font-weight: bold;
      color: #1d2b36;
      padding-bottom: 10px;
      border-bottom: 1px solid #ccc;
    }
    .btnGroups {
      text-align: left;
      margin-left: 16px;
    }
    .address-select {
      display: inline-block;
      margin-bottom: 20px;
    }
    .el-textarea {
      width: 350px;
    }
    .el-radio-group {
      margin-top: 3px;
    }
  }
  .el-dialog--small {
    width: 30%;
    .el-input {
      width: 55%;
    }
  }
  .imgShow {
    text-align: center;
    img {
      max-width: 100%;
      height: auto;
    }
    .el-dialog--small {
      width: 50%;
    }
  }
}
</style>
